import React, { useMemo, useState, useEffect } from 'react';

const SUB_BLOCKS_BY_OP = {
  MECANIZAR: ['EXT', 'Pasante_INT', 'Ciego_INT'],
  TALADRO: ['Agujeros'],
  CHAVETERO: ['Chaveteros'],
  TALLADO: ['Engranajes'],
  MECANIZAR_2FASE: ['EXT', 'INT'],
};

const FIELDS_BY_OP_SUB = {
  'MECANIZAR.EXT':         [{ key: 'D1', type: 'number' }, { key: 'L1', type: 'number' }, { key: 'tolerancia', type: 'text' }],
  'MECANIZAR.Pasante_INT': [{ key: 'D1', type: 'number' }, { key: 'L1', type: 'number' }, { key: 'tolerancia', type: 'text' }],
  'MECANIZAR.Ciego_INT':   [{ key: 'D1', type: 'number' }, { key: 'L1', type: 'number' }, { key: 'tolerancia', type: 'text' }],
  'TALADRO.Agujeros':      [{ key: 'Diametro', type: 'number' }, { key: 'N_agujeros', type: 'number' }, { key: 'Profundidad', type: 'number' }, { key: 'Rosca_SiNo', type: 'boolean' }],
  'CHAVETERO.Chaveteros':  [{ key: 'Ancho', type: 'number' }, { key: 'Longitud', type: 'number' }, { key: 'Profundidad', type: 'number' }],
  'TALLADO.Engranajes':    [{ key: 'M', type: 'number' }, { key: 'Z', type: 'number' }, { key: 'Ap', type: 'number' }, { key: 'Beta', type: 'number' }, { key: 'Ancho', type: 'number' }],
  'MECANIZAR_2FASE.EXT':   [{ key: 'D1', type: 'number' }, { key: 'L1', type: 'number' }, { key: 'tolerancia', type: 'text' }],
  'MECANIZAR_2FASE.INT':   [{ key: 'D1', type: 'number' }, { key: 'L1', type: 'number' }, { key: 'tolerancia', type: 'text' }],
  'RECTIFICAR_DIAMETROS':  [{ key: 'Diametro_exterior', type: 'number' }, { key: 'N_Diametros', type: 'number' }, { key: 'Texto_Rectificado', type: 'boolean' }],
  'RECTIFICAR_FLANCOS':    [{ key: 'Rz_flanco', type: 'number' }],
  'TALLAR_ESTRIAS':        [{ key: 'Diametro_max', type: 'number' }, { key: 'Numero_dientes', type: 'number' }, { key: 'Long_tallado', type: 'number' }],
  'RECTIFICAR_ESTRIAS':    [{ key: 'Ancho_forma', type: 'number' }, { key: 'Ancho_perfil', type: 'number' }],
};

const AUTOFILL_BY_OP_SUB_CLASS = {
  'MECANIZAR.EXT|Diameter': 'D1',
  'MECANIZAR.EXT|Length': 'L1',
  'MECANIZAR.Pasante_INT|Diameter': 'D1',
  'MECANIZAR.Pasante_INT|Length': 'L1',
  'MECANIZAR.Ciego_INT|Diameter': 'D1',
  'MECANIZAR.Ciego_INT|Length': 'L1',
  'TALADRO.Agujeros|Diameter': 'Diametro',
  'TALADRO.Agujeros|Thread': 'Diametro',
  'TALADRO.Agujeros|Length': 'Profundidad',
  'CHAVETERO.Chaveteros|Length': 'Ancho',
  'TALLADO.Engranajes|Length': 'Ancho',
  'MECANIZAR_2FASE.EXT|Diameter': 'D1',
  'MECANIZAR_2FASE.EXT|Length': 'L1',
  'MECANIZAR_2FASE.INT|Diameter': 'D1',
  'MECANIZAR_2FASE.INT|Length': 'L1',
  'RECTIFICAR_DIAMETROS|Diameter': 'Diametro_exterior',
  'RECTIFICAR_DIAMETROS|Roughness': 'N_Diametros',
  'RECTIFICAR_FLANCOS|Roughness': 'Rz_flanco',
  'TALLAR_ESTRIAS|Diameter': 'Diametro_max',
  'TALLAR_ESTRIAS|Length': 'Long_tallado',
  'RECTIFICAR_ESTRIAS|Length': 'Ancho_forma',
};

export function parseNumber(s) {
  if (s === '' || s === null || s === undefined) return null;
  const cleaned = String(s).replace(',', '.').trim();
  const n = parseFloat(cleaned);
  return Number.isFinite(n) ? n : null;
}

export function getAvailableOps(enabledOperations, classYolo) {
  const enabled = Array.isArray(enabledOperations) && enabledOperations.length > 0
    ? enabledOperations
    : Object.keys(SUB_BLOCKS_BY_OP).concat(['RECTIFICAR_DIAMETROS', 'RECTIFICAR_FLANCOS', 'TALLAR_ESTRIAS', 'RECTIFICAR_ESTRIAS']);
  const ops = new Set();
  enabled.forEach((op) => {
    const subs = SUB_BLOCKS_BY_OP[op];
    if (subs) {
      for (const sub of subs) {
        if (AUTOFILL_BY_OP_SUB_CLASS[`${op}.${sub}|${classYolo}`]) { ops.add(op); break; }
      }
    } else if (AUTOFILL_BY_OP_SUB_CLASS[`${op}|${classYolo}`]) {
      ops.add(op);
    }
  });
  return Array.from(ops);
}

export function getSubsForOpClass(op, classYolo) {
  const subs = SUB_BLOCKS_BY_OP[op];
  if (!subs) return [];
  return subs.filter((sub) => AUTOFILL_BY_OP_SUB_CLASS[`${op}.${sub}|${classYolo}`]);
}

function getCurrentMatch(detection) {
  const matches = (detection?.extras || []).find((e) => e?.label === '_matches')?.value;
  if (!Array.isArray(matches) || matches.length === 0) return null;
  return matches[0];
}

function getItemFromJson(om, opPath, instanceIdx, page) {
  if (!om || typeof om !== 'object' || !opPath) return null;
  const keys = opPath.split('.');
  let cur = om;
  for (const k of keys) {
    if (!cur || typeof cur !== 'object') return null;
    cur = cur[k];
  }
  if (!cur) return null;
  if (Array.isArray(cur)) {
    if (typeof instanceIdx !== 'number') return null;
    if (typeof page === 'number') {
      const tagged = cur.some((it) => it && typeof it._page_number === 'number');
      if (tagged) {
        const pageItems = cur.filter((it) => it && it._page_number === page);
        return pageItems[instanceIdx] || null;
      }
    }
    return cur[instanceIdx] || null;
  }
  return cur;
}

export function detectionIsAssignable(classYolo, enabledOperations) {
  return getAvailableOps(enabledOperations, classYolo).length > 0;
}

const DetectionMatchEditor = ({
  detection,
  currentOverride,
  currentMatch: targetMatchProp,
  operacionesMecanizado,
  enabledOperations,
  onSave,
  onCancel,
}) => {
  const classYolo = detection.class_name;
  const detectionValue = parseNumber(detection.value);

  const currentMatch = useMemo(
    () => targetMatchProp || getCurrentMatch(detection),
    [targetMatchProp, detection],
  );
  const matchItem = useMemo(
    () => (currentMatch ? getItemFromJson(operacionesMecanizado, currentMatch.op_path, currentMatch.instance_idx, currentMatch.page) : null),
    [currentMatch, operacionesMecanizado],
  );

  const availableOps = useMemo(() => getAvailableOps(enabledOperations, classYolo), [enabledOperations, classYolo]);
  const fallbackOpPath = currentOverride?.op_path || currentMatch?.op_path || '';
  const initialOp = fallbackOpPath.split('.')[0] || availableOps[0] || '';
  const initialSubs = getSubsForOpClass(initialOp, classYolo);
  const initialSub = fallbackOpPath.split('.').slice(1).join('.') || initialSubs[0] || '';
  const [op, setOp] = useState(initialOp);
  const [sub, setSub] = useState(initialSub);

  const fieldsDef = useMemo(() => {
    const key = sub ? `${op}.${sub}` : op;
    return FIELDS_BY_OP_SUB[key] || [];
  }, [op, sub]);

  const autofillKey = useMemo(() => {
    const k = sub ? `${op}.${sub}|${classYolo}` : `${op}|${classYolo}`;
    return AUTOFILL_BY_OP_SUB_CLASS[k] || null;
  }, [op, sub, classYolo]);

  const buildInitialValues = () => {
    const init = {};
    fieldsDef.forEach((f) => {
      const fromOverride = currentOverride?.fields?.[f.key];
      const fromMatch = matchItem?.[f.key];
      if (fromOverride !== undefined) {
        init[f.key] = f.type === 'boolean' ? !!fromOverride : String(fromOverride ?? '');
      } else if (fromMatch !== undefined && fromMatch !== null && fromMatch !== '') {
        init[f.key] = f.type === 'boolean' ? !!fromMatch : String(fromMatch);
      } else if (f.key === autofillKey && detectionValue !== null) {
        init[f.key] = String(detectionValue);
      } else {
        init[f.key] = f.type === 'boolean' ? false : '';
      }
    });
    return init;
  };

  const [values, setValues] = useState(buildInitialValues);

  useEffect(() => {
    setValues(buildInitialValues());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fieldsDef, autofillKey, detectionValue, currentOverride, matchItem]);

  useEffect(() => {
    const subs = getSubsForOpClass(op, classYolo);
    if (subs.length > 0 && !subs.includes(sub)) setSub(subs[0]);
    if (subs.length === 0 && sub) setSub('');
  }, [op, classYolo, sub]);

  const handleChange = (key, raw, type) => {
    setValues((prev) => ({ ...prev, [key]: type === 'boolean' ? !!raw : raw }));
  };

  const handleSave = () => {
    const opPath = sub ? `${op}.${sub}` : op;
    const fields = {};
    fieldsDef.forEach((f) => {
      const v = values[f.key];
      if (f.type === 'boolean') fields[f.key] = v ? 1 : 0;
      else if (f.type === 'number') {
        const n = parseNumber(v);
        if (n !== null) fields[f.key] = n;
      } else {
        const s = String(v ?? '').trim();
        if (s !== '') fields[f.key] = s;
      }
    });
    onSave({ op_path: opPath, fields });
  };

  const subBlocks = getSubsForOpClass(op, classYolo);

  return (
    <div className="match-editor">
      <div className="match-editor-headrow">
        <label className="match-editor-field">
          <span>Operación</span>
          <select value={op} onChange={(e) => setOp(e.target.value)}>
            {availableOps.length === 0 && <option value="">(ninguna disponible)</option>}
            {availableOps.map((o) => <option key={o} value={o}>{o}</option>)}
          </select>
        </label>
        {subBlocks.length > 0 && (
          <label className="match-editor-field">
            <span>Sub-bloque</span>
            <select value={sub} onChange={(e) => setSub(e.target.value)}>
              {subBlocks.map((s) => <option key={s} value={s}>{s}</option>)}
            </select>
          </label>
        )}
      </div>

      {fieldsDef.length > 0 && (
        <>
          <div className="match-editor-divider"><span>Datos del elemento</span></div>
          <div className="match-editor-fields">
            {fieldsDef.map((f) => {
              const isAuto = f.key === autofillKey;
              if (f.type === 'boolean') {
                return (
                  <label key={f.key} className={`match-editor-field ${isAuto ? 'is-auto' : ''}`}>
                    <span>{f.key}</span>
                    <input type="checkbox" checked={!!values[f.key]} onChange={(e) => handleChange(f.key, e.target.checked, 'boolean')} />
                  </label>
                );
              }
              return (
                <label key={f.key} className={`match-editor-field ${isAuto ? 'is-auto' : ''}`}>
                  <span>{f.key}{isAuto ? ' (auto)' : ''}</span>
                  <input
                    type={f.type === 'number' ? 'number' : 'text'}
                    step="any"
                    value={values[f.key] ?? ''}
                    placeholder={isAuto ? 'desde la detección' : '—'}
                    onChange={(e) => handleChange(f.key, e.target.value, f.type)}
                  />
                </label>
              );
            })}
          </div>
        </>
      )}

      <div className="match-editor-actions">
        <button className="match-editor-save" onClick={handleSave} disabled={fieldsDef.length === 0}>Guardar</button>
        <button className="match-editor-cancel" onClick={onCancel}>Cancelar</button>
      </div>
    </div>
  );
};

export default DetectionMatchEditor;
